import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import { borderGrey } from 'common/constants/colors';

interface PaneHeaderProps {
    paneName: string;
    onAdd?: () => void;
}

const PaneHeader = ({ paneName, onAdd }: PaneHeaderProps) => (
  <div
    style={{
      alignItems: 'end',
      background: '#F2F4F7',
      borderBottom: `solid 1px ${borderGrey}`,
      display: 'flex',
      justifyContent: 'space-between',
      padding: '20px 0',
    }}
  >
    <div
      style={{
        display: 'flex',
        fontSize: '14px',
        fontWeight: 'bold',
        paddingLeft: '20px',
        textTransform: 'uppercase',
      }}
    >
      {paneName}
    </div>
    {onAdd && (
      <div onClick={onAdd} role="button" style={{ paddingRight: '20px' }}>
        <FontAwesomeIcon icon={faPlus} />
      </div>
    )}
  </div>
);

export default PaneHeader;
